import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

const API = 'https://carriera-backend.onrender.com';

// Silently refresh expired tokens. On any 401, try once with the refresh token.
// If refresh also fails, clear storage and redirect to login.
axios.interceptors.response.use(
  response => response,
  async error => {
    const original = error.config;
    const isRefreshCall = original?.url?.includes('/api/auth/refresh');
    if (error.response?.status === 401 && !original._retry && !isRefreshCall) {
      original._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const { data } = await axios.post(`${API}/api/auth/refresh`, { refresh_token: refreshToken });
          localStorage.setItem('token', data.token);
          localStorage.setItem('refresh_token', data.refresh_token);
          original.headers = { ...original.headers, Authorization: `Bearer ${data.token}` };
          return axios(original);
        } catch {
          // Refresh failed — fall through to logout
        }
      }
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
